<script setup>
import { onMounted, watch } from 'vue'
import { useReservationsStore } from '@/stores/reservations'
import PosVerticalTabNav from './PosVerticalTabNav.vue'
import PosFooter from './PosFooter.vue'

const { loadTabletMode } = useTabletMode()
const userStore = useUserStore()
const reservationsStore = useReservationsStore()

watch(() => userStore.activeBusinessId, async (businessId) => {
  if (businessId) {
    await reservationsStore.fetchPendingCount(businessId)
  }
}, { immediate: true })

onMounted(async () => {
  await loadTabletMode()
  if (userStore.activeBusinessId) {
    await reservationsStore.fetchPendingCount(userStore.activeBusinessId)
  }
})
</script>

<template>
  <div class="pos-layout">
    <PosVerticalTabNav />
    <div class="pos-main-content">
      <div class="pos-page-content">
        <slot />
      </div>
      <PosFooter />
    </div>
  </div>
</template>

<style scoped>
.pos-layout {
  display: flex;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.pos-main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: rgb(var(--v-theme-background));
}

.pos-page-content {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>
